import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import Button from "@material-ui/core/Button";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import { NotificationManager } from "react-notifications";
import MainService from "../../Common/MainService";
import CustomPopup from "../../Common/CustomPopup/CustomPopupComponent";
import CircularProgress from "@material-ui/core/CircularProgress";
import socketIOClient from "socket.io-client";
import Map from "../../Common/googleMap/Map";
import Box from "@material-ui/core/Box";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: 250,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  uploadButton: {
    margin: theme.spacing(1),
  },
  fab: {
    position: "fixed",
    bottom: theme.spacing(5),
    right: theme.spacing(5),
    zIndex: 10,
    color: "#fff",
  },
}));

export default function MyAssetsPageComponent() {
  const classes = useStyles();
  const { user } = MainService.getLocalData();
  const { username, parentId } = user;
  const [isLoading, setIsLoading] = useState(true);
  const [assetDetailsPopup, setShowAssetDetailsPopup] = useState(false);
  const [assetsData, setAssetsData] = useState([]);
  /* Assset values set state */
  const [AssetDeveloperID, setAssetDeveloperID] = useState("");
  const [AssetVerticalID, setAssetVerticalID] = useState("");
  const [AssetCategory, setAssetCategory] = useState("");
  const [AssetType, setAssetType] = useState("");
  const [AssetModelId, setAssetModelId] = useState("");
  const [AssetId, setAssetId] = useState("");
  const [AssetStatus, setAssetStatus] = useState("");
  const [AssetFriendlyName, setAssetFriendlyName] = useState("");
  const [AssetLatutude, setAssetLatitude] = useState("");
  const [AssetLongitude, setAssetLongitude] = useState("");
  const [AssetWhitelabelCost, setAssetWhitelabelCost] = useState("");
  const [AssetSellingCost, setAssetSellingCost] = useState("");
  const [AssetImage, setAssetImage] = useState("");
  const [assetsGridView,setAssetsGridView] = useState(true);
  /* Asset Live Location */
  const [assetMonitoringView, setAssetMonitoringView] = useState(false);
  const [selectedAssetId, setSelectedAssetId] = useState("");
  
  const [ssetMonitoringStatus, setAssetMonitoringStatus] = useState("");
 
  const [ssetMonitorTimestamp, setAssetMonitorTimestamp] = useState("");

  const [markers, setMarkers] = useState([]);

  useEffect(() => {
    myAssetsList();
  }, []);

  const myAssetsList = () => {
    
    MainService.myAssetsList(username)
      .then((data) => {
        console.log("My assets data in investor:",data)
        setIsLoading(false);
        setAssetsData(data);
      })
      .catch((e) => {
        setIsLoading(false);
        console.error(e);
        return NotificationManager.error(e);
      });
  };

  const assetDetailsClick = (sites) => {
    setShowAssetDetailsPopup(!assetDetailsPopup);
    MainService.getAssetDetails(
      sites.id,
      sites.assetverticalId,
      sites.categoryType,
      sites.assetType,
      sites.modelId,
      sites.assetId
    )
      .then((data) => {
        setAssetDeveloperID(data.assetdeveloperid);
        setAssetVerticalID(data.assetverticalId);
        setAssetCategory(data.category);
        setAssetType(data.assetType);
        setAssetModelId(data.modelid);
        setAssetId(data.assetid);
        setAssetStatus(data.assetstatus);
        setAssetFriendlyName(data.friendlyname);
        setAssetLatitude(data.latitude);
        setAssetLongitude(data.longitude);
        setAssetWhitelabelCost(data.whitelabelcost);
        setAssetSellingCost(data.sellingcost);
        // setAssetImage(data.image);
        if (data.image === "null") {
          setAssetImage(
            ""
            //  "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"
          );
        } else {
          setAssetImage(data.image);
        }
      })
      .catch((e) => {
        console.error(e);
        return NotificationManager.error(e);
      });
  };

  const preMatureSaleClick = (assetId, status) => {
    if (status === "premature-sale" || status === "verified") {
      return NotificationManager.success("It's already in premature-sale");
    } else {
      let preMatureSaleData = {
        status: "premature-sale",
      };

      const preMatureSaleDataBody = JSON.stringify(preMatureSaleData);

      MainService.preMatureSale(preMatureSaleDataBody, assetId)
        .then((res) => {
          return NotificationManager.success(res["SUCCESS MESSAGE"]);
        })
        .catch((e) => {
          return NotificationManager.error(e);
        });
    }
  };
  /* Asset Details */
  const closeAssetModal = (
    <span
      onClick={() => {
        setShowAssetDetailsPopup(!assetDetailsPopup);
      }}
    >
      X
    </span>
  );
  const titleAsset = "More Asset Details";
  const assetDetailsBody = (
    <div style={{ marginTop: "20px !important" }}>
      <div className="poupupContent">
        <img
          alt=""
          src={`data:image/jpeg;base64,${AssetImage}`}
          width="200"
          height="200"
        />
        <p>
          <b>NAV:</b>
          {AssetSellingCost}
        </p>
        <p>
          <b>Assetdeveloper ID:</b>
          {AssetDeveloperID}
        </p>
        <p>
          <b>AssetverticalId</b>
          {AssetVerticalID}
        </p>
        <p>
          <b>Category:</b>
          {AssetCategory}
        </p>
        <p>
          <b>AssetType:</b>
          {AssetType}
        </p>
        <p>
          <b>Model ID:</b>
          {AssetModelId}
        </p>
        <p>
          <b>Assetid:</b>
          {AssetId}
        </p>
        <p>
          <b>Assetstatus:</b>
          {AssetStatus}
        </p>
        <p>
          <b>Latitude:</b>
          {AssetLatutude}
        </p>
        <p>
          <b>Longitude:</b>
          {AssetLongitude}
        </p>
        <p>
          <b>Friendlyname:</b>
          {AssetFriendlyName}
        </p>
        <p>
          <b>Whitelabelcost:</b>
          {AssetWhitelabelCost}
        </p>

        {/* <img src={AssetImage} alt="img data"/> */}
        <br />
        <Button
          style={{ alignContent: "center" }}
          variant="contained"
          color="primary"
          className="registerBtn"
          type="button"
          // onClick={() => sitesInvestClick(siteID)}
        >
          Invest
        </Button>
      </div>

      <FormControl
        fullWidth={true}
        className="forgotPwdLink"
        onClick={() => {
          setShowAssetDetailsPopup(!assetDetailsPopup);
        }}
        style={{
          marginBottom: "20px",
          textAlign: "center",
          boxOrient: "0",
          display: "block",
          fontSize: "20",
        }}
      >
        Cancel
      </FormControl>
    </div>
  );

    /* Asset Live Monitoring */

const createSocketLoc = () => {
  const ENDPOINT = window.socketUrl;
  const socket = socketIOClient(ENDPOINT);
console.log("location socket url:",socket,ENDPOINT);
  // Add a function to disconnect the socket
  const disconnectSocketLoc = () => {
    socket.disconnect();
  };

  return { socket, disconnectSocketLoc };
};

const assetMonitoringHandler = (siteId, assetId) => {
  setSelectedAssetId(assetId);
  
  setAssetMonitoringView(true);
  setAssetsGridView(false);
  
  const { socket, disconnectSocketLoc } = createSocketLoc();
  MainService.assetCurrentLocation(parentId, username, assetId)
    .then((res) => {
      console.log("current Location monitor:", res);

      if (res && res.geoLocation) {
        setSelectedAssetId(res.assetId);
        setAssetMonitoringStatus(res.status);
        setMarkers([...markers, { geoLocation: res.geoLocation }]);
        setAssetMonitorTimestamp(res.ts);

        socket.on(
          `tt/solution/${username}/site/${siteId}/asset/${assetId}/LOC`,
          (data) => {
            const liveData = JSON.parse(data.payload);
            console.log("live data", liveData.geoLocation);
            setMarkers([...markers, { geoLocation: liveData.geoLocation }]);
          }
        );

        return () => {
          disconnectSocketLoc(); // Disconnect the socket when the component unmounts
        };
      } else {
        console.log("No geoLocation data available. Disconnecting socket.");
        // Optionally, add further handling or notifications for no geoLocation data.
        // Disconnect socket here.
        disconnectSocketLoc();
      }
    })
    .catch((e) => {
      console.error(e);
      return NotificationManager.error("Location not found");
    });
};
const backToHome = () => { 
  setAssetMonitoringView(false);
  setAssetsGridView(true); 
};
const getLocationHandler = (props) => {
  console.log(props);
};

  return (
    <>
      <Grid container spacing={2}>
        <a href="/main/invest">
          <Fab
            color="primary"
            size={"large"}
            aria-label="add"
            title="Add Asset"
            className={classes.fab}
          >
            <AddIcon></AddIcon>
          </Fab>
        </a>
        <CustomPopup
          closeButton={closeAssetModal}
          isOpen={assetDetailsPopup}
          closeModal={assetDetailsPopup}
          content={assetDetailsBody}
          title={titleAsset}
        />

        <Grid>
          <h4>My White Label Assets (Owned Assets)</h4>
          {assetsGridView === true ? (
            <Box sx={{ width: "100%", marginBottom: 30 }}>
              <div className="cardStyleForDashboardItems">
          {isLoading ? (
            <div className="cardStyleForDashboardItems">
              <CircularProgress />
            </div>
          ) : (
            <div className="cardStyleForDashboardItems">
              {assetsData.length > 0 ? (
                assetsData.map((assets, index) => (
                  <div key={index} className="cardStyleForDashboardItemsBody">
                    {/* <img src={`data:image/jpeg;base64,${AssetImage}`} width="200" height="200" /> */}
                    <p>
                      <b>FriendlyName:</b>
                      {assets.friendlyName}
                    </p>
                    <p>
                      <b>AAMC:</b>
                      {assets.id}
                    </p>
                    <p>
                      <b>Farm:</b>
                      {assets.siteFriendlyName}
                    </p>
                    <p>
                      <b>Breed:</b>
                      {assets.modelId}
                    </p>
                    <p>
                      <b>Asset Status:</b>
                      {assets.assetStatus}
                    </p>
                    <p>
                      <b>Todays Cost(NAV):</b>
                      {assets.sellingCost}
                    </p>
                  <div>
                    <Button
                      style={{ marginRight: "10px", padding: "4px" }}
                      variant="contained"
                      color="primary"
                      className="registerBtn"
                      type="button"
                      onClick={() => assetDetailsClick(assets)}
                    >
                      Details
                    </Button>
                    <Button
                      style={{ padding: "4px" }}
                      variant="contained"
                      color="primary"
                      className="registerBtn"
                      type="button"
                      onClick={() =>
                        assetMonitoringHandler(
                          assets.siteId,
                          assets.assetId,
                          
                        )
                      }
                    >
                      Track
                    </Button>
                    </div>
                    <br/>
                    <Button
                      style={{ padding: "4px" }}
                      variant="contained"
                      color="primary"
                      className="registerBtn"
                      type="button"
                      onClick={() =>
                        preMatureSaleClick(assets.assetId, assets.assetStatus)
                      }
                    >
                      Pre Mature Sale
                    </Button>
                  </div>
                ))
              ) : (
                <div>
                  <h4>Assets Not Found</h4>
                </div>
              )}
              {/* Asset Monitoring */}
          
            </div>
          )}
          </div>
          </Box>):null}
          
        </Grid>
        {assetMonitoringView === true ? (
            <Box sx={{ width: "100%", marginBottom: 30 }}>
              <h3>Asset Live Monitoring</h3>
              <br />
              <Button
                variant="contained"
                onClick={() => {
                  backToHome();
                }}
              >
                Back
              </Button>
              <Map
                routeLocationData={markers}
                getLocationHandler={getLocationHandler}
              />
              
            </Box>
          ) : null}
      </Grid>
    </>
  );
}
